import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CourseDetail from './CourseDetail';
import './Programs.css';
import Pricing from './Pricing';
import { API_BASE_URL } from '../config'; // <-- NEW: Import your dynamic URL

// Icons
import {
  FaRegClock, FaLightbulb, FaCheckCircle, FaVideo,
  FaChalkboardTeacher, FaQuestionCircle, FaGraduationCap,
  FaFolderOpen, FaFileAlt, FaBullseye, FaLaptopCode,
  FaMicrochip, FaChartBar, FaHardHat, FaFlask,
  FaDollarSign, FaHeartbeat, FaPaintBrush
} from 'react-icons/fa';

import sampleCertificateImg from '../utility/Main_Certificate.png';

// ✅ Move CATEGORIES here so you can safely delete the old static data file
const CATEGORIES = [
  { id: 'all', name: 'All Programs', icon: <FaBullseye /> },
  { id: 'tech', name: 'Tech', icon: <FaLaptopCode /> },
  { id: 'electronics', name: 'Electronics', icon: <FaMicrochip /> },
  { id: 'management', name: 'Management', icon: <FaChartBar /> },
  { id: 'civil', name: 'Civil', icon: <FaHardHat /> },
  { id: 'science', name: 'Science', icon: <FaFlask /> },
  { id: 'finance', name: 'Finance', icon: <FaDollarSign /> },
  { id: 'health', name: 'Health', icon: <FaHeartbeat /> },
  { id: 'arts', name: 'Arts', icon: <FaPaintBrush /> }
];

const Programs = ({ visible, onNavigate }) => {
  const [programs, setPrograms] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isCertModalOpen, setIsCertModalOpen] = useState(false);

  // 1. Fetch programs dynamically using API_BASE_URL
  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        // ✅ FIXED: No more hardcoded 127.0.0.1!
        const response = await axios.get(`${API_BASE_URL}/api/courses/programs/`);
        setPrograms(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching programs:", error);
        setLoading(false);
      }
    };

    if (visible) {
      fetchPrograms();
    }
  }, [visible]);

  // 2. Filter logic
  const filteredPrograms = selectedCategory === 'all'
    ? programs
    : programs.filter((p) => p.category_name && p.category_name.toLowerCase() === selectedCategory.toLowerCase());

  if (!visible) return null;

  return (
    <>
      <section className="why-choose-trekverse">
        {/* ... Keep all your existing why-choose-trekverse HTML exactly the same ... */}
        <div className="why-trek-container">
          <h2 className="why-trek-title">Why Choose TrekVerse?</h2>

          <div className="process-header">
            <div className="process-box">
              <span className="process-icon"><FaLightbulb color="#ffc107" /></span> Learning Challenges
            </div>
            <div className="process-arrow">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>
            </div>
            <div className="process-box process-box-solution">
              <span className="process-icon"><FaCheckCircle color="#1abc9c" /></span> How TrekVerse Encounters
            </div>
          </div>

          <div className="why-trek-content-grid">
            <div className="trek-challenges-col">
              <div className="simulated-messages">
                <p className="sim-msg">"I'm struggling to retain what is taught."</p>
                <p className="sim-msg">"I'm not getting any practical experience."</p>
                <p className="sim-msg sim-msg-long">"It's all solo study without peer support."</p>
              </div>

              <div className="mini-cert-showcase">
                <div className="mini-cert-header">
                  <FaGraduationCap className="mini-cert-icon" />
                  <span>Industry Ratified Certificate</span>
                </div>
                <div className="mini-cert-image-wrapper">
                  <img 
                    src={sampleCertificateImg} 
                    alt="TrekVerse Sample Certificate" 
                    className="mini-cert-image" 
                    onClick={() => setIsCertModalOpen(true)}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="trek-features-col">
              <div className="trek-features-grid">
                <div className="feature-card"><div className="feature-card-header"><span className="feature-icon feature-icon-purple"><FaVideo /></span> LIVE Interactive Session</div></div>
                <div className="feature-card"><div className="feature-card-header"><span className="feature-icon feature-icon-purple"><FaChalkboardTeacher /></span> Expert Industry Mentor</div></div>
                <div className="feature-card"><div className="feature-card-header"><span className="feature-icon feature-icon-purple"><FaQuestionCircle /></span> Dedicated query session</div></div>
                <div className="feature-card"><div className="feature-card-header"><span className="feature-icon feature-icon-purple"><FaGraduationCap /></span> Industry ratified certifications</div></div>
                <div className="feature-card"><div className="feature-card-header"><span className="feature-icon feature-icon-purple"><FaFolderOpen /></span> Portfolio worthy projects</div></div>
                <div className="feature-card"><div className="feature-card-header"><span className="feature-icon feature-icon-purple"><FaFileAlt /></span> Resume Building</div></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Pricing />

      <section className="programs">
        <div className="programs-container">
          <h2 className="programs-title">Our Programs</h2>
          <p className="programs-subtitle">Choose from our comprehensive range of programs</p>

          <div className="category-filters">
            {CATEGORIES.map((category) => (
              <button
                key={category.id}
                className={`category-btn ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.id)}
              >
                <span className="category-icon">{category.icon}</span>
                <span className="category-name">{category.name}</span>
              </button>
            ))}
          </div>

          {loading ? (
            <div className="loading-state">Loading TrekVerse Academy...</div>
          ) : (
            <div className="programs-grid">
              {filteredPrograms.map((program) => (
                <div key={program.id} className="program-card">
                  <div className="card-image-container">
                    {/* ✅ FIXED: Images now load dynamically from the correct environment! */}
                    <img
                      src={program.image?.startsWith('http') ? program.image : `${API_BASE_URL}${program.image}`}
                      alt={program.title}
                    />
                  </div>
                  <div className="card-header">
                    <h3 className="program-name">{program.title}</h3>
                  </div>

                  <p className="program-description">{program.description}</p>

                  <div className="program-meta">
                    <div className="meta-item">
                      <span className="meta-icon"><FaRegClock /></span>
                      <span className="meta-text">{program.duration}</span>
                    </div>
                  </div>

                  <div className="pricing-section">
                    <span className="current-price">₹{program.price}</span>
                    <span className="original-price">₹{program.original_price}</span>
                  </div>

                  <button
                    className="view-course-btn"
                    onClick={() => setSelectedCourse(program)}
                  >
                    View Course
                  </button>
                </div>
              ))}
            </div>
          )}

          {!loading && filteredPrograms.length === 0 && (
            <div className="no-programs">
              <p>No programs found. Check back soon!</p>
            </div>
          )}
        </div>
      </section>

      {selectedCourse && (
        <CourseDetail
          course={selectedCourse}
          onClose={() => setSelectedCourse(null)}
          onNavigate={onNavigate}
        />
      )}

      {isCertModalOpen && (
        <div 
          className="cert-modal-overlay" 
          onClick={() => setIsCertModalOpen(false)}
        >
          <div className="cert-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="cert-modal-close" onClick={() => setIsCertModalOpen(false)}>✕</button>
            <img src={sampleCertificateImg} alt="TrekVerse Certificate" className="cert-modal-full-image" />
          </div>
        </div>
      )}
    </>
  );
};

export default Programs;